import type { Entity } from '@models/Entity'

import { apiClient } from '../../../gateways/api'

export { fetchGeblokkeerdeWekenForEntity }

const fetchGeblokkeerdeWekenForEntity = async ({ id }: Entity) => {
  const { data } = await apiClient<string[]>({
    url: `/rest/project/${id}/geblokkeerdeweken`,
    method: 'GET',
  })

  return data
}
